import { Link } from 'react-router-dom';
interface BreadcrumbProps {
  pageName: string
  isVisable?: boolean
}
const Breadcrumb = ({ pageName, isVisable = true }: BreadcrumbProps) => {
  return (
    <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-title-md2 font-semibold">
        {pageName}
      </h2>

      {
        isVisable && <nav>
          <ol className="flex items-center gap-2">
            {/* <li>
              <Link to="/dashboard">Dashboard /</Link>
            </li>
            <li className="text-primary">{pageName}</li> */}
            <li>
              <Link to="/dashboard" className='flex w-full justify-center items-center rounded bg-primary py-1.5 px-2 font-medium text-white text'>Back To Dashboard</Link>
            </li>
            {/* <li className="text-primary">{pageName}</li> */}
          </ol>
        </nav>
      }
    </div>
  );
};

export default Breadcrumb;
